/* eslint-disable react/no-unescaped-entities */
import { lazy } from 'react';
import { PageLoading } from '../../../appComponents/PageLoading';
import { wrapLazyNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';

const PrivacyPolicyPageContent = lazy(
  () => import('./PrivacyPolicyContent.web'),
);

export const PrivacyPolicyScreen = wrapLazyNavigatorScreen(
  () => {
    return <PrivacyPolicyPageContent />;
  },
  props => ({
    title: 'Privacy Policy',
    headerShown: !(props.route.params as any)?.['popup'],
    suspenseFallback: <PageLoading style={{ backgroundColor: '#fff' }} />,
  }),
);
